import { buildUrl } from 'app/router/helpers/buildUrl';

const PRICING_PROMO_TOS_URL = buildUrl(
  '/pricing-promo-terms-conditions/index.html',
);

export { PRICING_PROMO_TOS_URL };
